<!--The content below is only a placeholder and can be replaced.-->


<router-outlet></router-outlet>

  


  <div *ngIf="false">

  <h3>Inputs</h3>
  <label class="iq-label">Title</label>
  <input type="text" class="iq-input" />

  <h3>Button Primary</h3>
  <h4>Blue</h4>
  <button type="button" class="button primary-1">Submit</button>
  <button type="button" class="button primary-1" disabled>Disabled</button>
  <h4>Pink</h4>
  <button type="button" class="button primary-2">Submit</button>
  <button type="button" class="button primary-2" disabled>Disabled</button>
  <h4>White</h4>
  <button type="button" class="button primary-3">Submit</button>
  <button type="button" class="button primary-3" disabled>Disabled</button>

  <h3>Button Secondary</h3>
  <h4>Blue</h4>
  <button type="button" class="button secondary-1">Submit</button>
  <button type="button" class="button secondary-1" disabled>Disabled</button>
  <h4>Pink</h4>
  <button type="button" class="button secondary-2">Submit</button>
  <button type="button" class="button secondary-2" disabled>Disabled</button>
    <h4>White</h4>
  <button type="button" class="button secondary-3">Submit</button>
  <button type="button" class="button secondary-3" disabled>Disabled</button>

  <h4>No outline</h4>
  <button type="button" class="button secondary-4">Submit</button>
  <button type="button" class="button secondary-4" disabled>Disabled</button>



  <h3>Button Tertiary</h3>
  <h4>Blue</h4>
  <button type="button" class="button tertiary-1">Submit</button>
  <button type="button" class="button tertiary-1" disabled>Disabled</button>
  <h4>Pink</h4>
  <button type="button" class="button tertiary-2">Submit</button>
  <button type="button" class="button tertiary-2" disabled>Disabled</button>

</div>

 